import Link from 'next/link';

function Breadcrumb({ breadcrumbs }) {
  return (
    <div className="breadcrumb">
      {breadcrumbs?.map((item, index, arr) => {
        const isLastElement = index === arr.length - 1;
        return (
          <div
            key={item?.title}
            className={`path ${isLastElement ? 'last' : ''}`}
          >
            {!isLastElement ? (
              <Link href={item.link}>{item.title}</Link>
            ) : (
              <span>{item.title}</span>
            )}
          </div>
        );
      })}
      <style jsx>{`
        .breadcrumb {
          display: flex;
          flex-flow: row wrap;
          font-size: 13px;
          line-height: 35px;
          font-weight: 400;
          margin-top: 10px;
        }
        .breadcrumb .path {
          color: var(--breadcrumb-grey);
        }
        .breadcrumb .path.last:after {
          display: none;
        }
        .breadcrumb .path:after {
          content: '>';
          width: 8px;
          height: 8px;
          margin: 6px;
        }
        .breadcrumb .path.last {
          color: var(--breadcrumb-black);
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

export default Breadcrumb;
